import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { DropdownComponent } from './dropdown.component';

@NgModule({
  declarations: [
    DropdownComponent,
  ],
  exports: [
    DropdownComponent,
  ],
  imports: [
    CommonModule,
    NgbModule,
  ],
})
export class DropdownModule { }